'use-client';
import * as React from 'react';
import type {
  GoogleMapProps,
  IGoogleMapsImperativeActions,
} from '../GoogleMap.types';
import GoogleMapLegacy from './GoogleMapLegacy';
import GoogleMapReact from './GoogleMapReact';

const GoogleMap: React.ForwardRefRenderFunction<
  IGoogleMapsImperativeActions,
  GoogleMapProps & { isReactGoogleMap?: boolean }
> = (props, forwardRef) => {
  const { isReactGoogleMap, ...restProps } = props;

  if (isReactGoogleMap) {
    return <GoogleMapReact {...restProps} ref={forwardRef} />;
  }

  return <GoogleMapLegacy {...restProps} ref={forwardRef} />;
};

export default React.forwardRef(GoogleMap);
